import { createSelector, createSlice } from '@reduxjs/toolkit';
import { getLanguageFromLocaleTag, } from '@stepstone-platform/platform-apis';
import merge from 'deepmerge';
export const initialSiteConfigState = {
    loginregistration: {
        profileUrl: '',
        membersAreaUrl: '',
        brandTrackingType: 'continental',
        brandLogo: '',
        logoBrandName: '',
        languageSpecificConfig: {
            en: {
                termsOfUseUrl: '',
                dataProtectionPolicyUrl: '',
            },
        },
        socialButtons: {
            google: true,
            facebook: true,
            apple: true,
        },
        passwordlessLogin: false,
        login: {
            stayLoggedIn: true,
            showForgotPassword: true,
            forgotPasswordUrl: '',
            showRegisterLink: true,
            showRecruiterLoginLink: true,
            loginRecruiterUrl: '',
        },
        registration: {
            registrationConsentPosition: 'bottom',
            showLoginLink: true,
            formSpecific: {
                keepMeInformedCheckbox: true,
            },
            registrationSuccessModal: {
                redirectToProfileUrl: '',
                redirectToJobSearchUrl: null,
            },
        },
        linkedInProfileImportEnabled: true,
    },
    locales: [],
    encodedGTLibraryUrl: '',
    currentLocale: 'en-GB',
    platformType: '',
    device: '',
    configInitialized: false,
};
export const siteConfigSlice = createSlice({
    name: 'siteConfig',
    initialState: initialSiteConfigState,
    reducers: {
        populateSiteConfig: (state, actions) => {
            state.locales = actions.payload.locales;
            state.loginregistration = actions.payload.loginregistration;
            state.platformType = actions.payload.platformType;
            state.device = actions.payload.device;
            state.configInitialized = actions.payload.configInitialized;
            state.encodedGTLibraryUrl = actions.payload.encodedGTLibraryUrl;
            state.currentLocale = actions.payload.currentLocale;
        },
        overrideConfig: (state, actions) => {
            state.loginregistration = merge(state.loginregistration, actions.payload);
        },
        assignBrandLogo: (state, actions) => {
            state.loginregistration.brandLogo = actions.payload;
        },
    },
});
export const { populateSiteConfig, overrideConfig, assignBrandLogo } = siteConfigSlice.actions;
const siteConfigState = (state) => state.core.siteConfig;
export const platformTypeSelector = createSelector(siteConfigState, (state) => state.platformType);
export const isBrowserSelector = createSelector(siteConfigState, (state) => state.device === 'browser');
export const brandTrackingTypeSelector = createSelector(siteConfigState, (state) => state.loginregistration.brandTrackingType);
export const brandLogoSelector = createSelector(siteConfigState, (state) => state.loginregistration.brandLogo);
export const logoBrandNameSelector = createSelector(siteConfigState, (state) => state.loginregistration.logoBrandName);
export const configInitializedSelector = createSelector(siteConfigState, (state) => state.configInitialized);
export const isGoogleEnabledSelector = createSelector(siteConfigState, (state) => state.loginregistration.socialButtons?.google ||
    // TODO: remove that after cache cleanup, it's a workaround for the case when old config is loaded
    state.loginregistration.login['loginWithGoogle']);
export const isFacebookEnabledSelector = createSelector(siteConfigState, (state) => state.loginregistration.socialButtons?.facebook ||
    state.loginregistration.login['loginWithFacebook']);
export const isAppleEnabledSelector = createSelector(siteConfigState, (state) => state.loginregistration.socialButtons?.apple);
export const isPasswordlessEnabledSelector = createSelector(siteConfigState, (state) => state.loginregistration.passwordlessLogin);
export const registrationConsentPositionSelector = createSelector(siteConfigState, (state) => state.loginregistration.registration.registrationConsentPosition);
export const loginRecruiterUrlSelector = createSelector(siteConfigState, (state) => state.loginregistration.login.loginRecruiterUrl);
export const loginRecruiterShowLinkSelector = createSelector(siteConfigState, (state) => state.loginregistration.login.showRecruiterLoginLink);
export const hasKeepMeInformedEnabled = createSelector(siteConfigState, (state) => state.loginregistration.registration.formSpecific.keepMeInformedCheckbox);
export const loginConfigSelector = createSelector(siteConfigState, (state) => state.loginregistration.login);
export const registrationConfigSelector = createSelector(siteConfigState, (state) => state.loginregistration.registration);
export const loginregistrationSelector = createSelector(siteConfigState, (state) => state.loginregistration);
export const currentLocaleSelector = createSelector(siteConfigState, (state) => state.currentLocale);
export const languageSpecificConfigSelector = createSelector(siteConfigState, currentLocaleSelector, (state, locale) => {
    const langStringFromLocale = getLanguageFromLocaleTag(locale);
    return state.loginregistration.languageSpecificConfig[langStringFromLocale];
});
export const encodedGTLibraryUrlSelector = createSelector(siteConfigState, (state) => state.encodedGTLibraryUrl);
export const profileUrlSelector = createSelector(siteConfigState, (state) => state.loginregistration.profileUrl);
export const linkedInProfileImportEnabledSelector = createSelector(siteConfigState, (state) => state.loginregistration.linkedInProfileImportEnabled);
export default siteConfigSlice.reducer;
//# sourceMappingURL=siteConfigSlice.js.map